import { useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Products from "@/components/site/Products";
import Certifications from "@/components/site/Certifications";
import Process from "@/components/site/Process";
import GlobalReach from "@/components/site/GlobalReach";
import CurrencyConverter from "@/components/site/CurrencyConverter";
import Testimonials from "@/components/site/Testimonials";
import Insights from "@/components/site/Insights";
import RFQ from "@/components/site/RFQ";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import useReveal from "@/hooks/useReveal";
import useLenis from "@/hooks/useLenis";

export default function Home() {
  useReveal();
  useLenis();
  useEffect(() => {
    document.title = "Aadiyogis EXIM Traders — Global Agri-Commodity Exporters";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "Aadiyogis EXIM Traders — global exporters of premium grains, spices, oilseeds and fresh produce. Request a quote from our trade desk.");
    if (window.location.hash) {
      const id = window.location.hash;
      setTimeout(() => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    }
  }, []);
  return (
    <div data-testid="home-page" className="bg-[#F9F8F6]">
      <Header />
      <Hero />
      <About />
      <Products />
      <Certifications />
      <Process />
      <GlobalReach />
      <CurrencyConverter />
      <Testimonials />
      <Insights />
      <RFQ />
      <Footer />
      <WhatsAppButton />
      <ChatWidget />
    </div>
  );
}
